import MobileVideoStatus from './MobileVideoStatus';

export default MobileVideoStatus;
